import { render } from "./TaxServiceDetail.vue?vue&type=template&id=0ec573ab"
import script from "./TaxServiceDetail.vue?vue&type=script&lang=js"
export * from "./TaxServiceDetail.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__